<button disableNavigation (click)="onClick.emit()" [class]="'btn btn-' + type">
  <ng-content></ng-content>
</button>
